import React from 'react';
import {filter, filterMobile, filterWhite} from '../assets/images/images';

export default function FilterButton({
  setOpenFilter,
  openFilter,
  className = '',
  textClassName = '',
}) {
  const filterCount = Number(sessionStorage.getItem('filterCount') || 0);
  return (
    <>
      <button
        onClick={() => setOpenFilter(!openFilter)}
        className="md:hidden block"
      >
        <img src={filterMobile} alt="filter" className="w-8 h-8" />
      </button>
      <button
        onClick={() => setOpenFilter(!openFilter)}
        className={`${className} hidden md:flex items-center gap-2 px-[20px] py-1 font-medium outline outline-1 rounded focus-visible:outline-brandBlue ${
          filterCount === 0
            ? 'bg-white80 text-grey80 outline-grey60'
            : 'bg-brandBlue text-white outline-none'
        }`}
      >
        <img
          src={filterCount === 0 ? filter : filterWhite}
          alt=""
          width={24}
          height={24}
        />
        <span className={`${textClassName} text-sm -mb-1`}>Filter</span>
        <span
          className={`${
            filterCount === 0 ? 'hidden' : 'flex'
          } items-center justify-center text-xs   text-brandBlue min-w-[18px] min-h-[18px] bg-white rounded-full`}
        >
          {filterCount}
        </span>
      </button>
    </>
  );
}
